import React, { createContext, useState, useContext } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { lightTheme } from '../../theme/lightTheme';
import { Padding } from '@mui/icons-material';
// import * as globalstyles from '../../theme/global';
// import * as theme from '../../theme/lightTheme';


const ConfirmContext = createContext(message => Promise.resolve(false));

export const ConfirmProvider = ({ children }) => {
  const [state, setState] = useState({ open: false, message: '', resolve: () => {} });

  const confirm = message => new Promise(resolve => {
    setState({ open: true, message, resolve });
  });

  const handleClose = result => {
    state.resolve(result);
    setState({ ...state, open: false });
  };

  return (
    <ConfirmContext.Provider value={confirm} >
      {children}
      <Dialog open={state.open} onClose={() => handleClose(false)}  >
        <DialogTitle sx={{paddingTop:'2rem', paddingX:'2rem'}}>Confirmar</DialogTitle>
        <DialogContent sx={{paddingX:'2rem'}}>{state.message}</DialogContent>
        <DialogActions sx={{paddingBottom:'2rem', paddingX:'2rem', gap: '0.7rem'}}>
          <Button variant='contained'  sx={{
            backgroundColor: lightTheme.palette.error.main,
            '&:hover': { backgroundColor: lightTheme.palette.error.dark }
          }}
          onClick={() => handleClose(false)}>Cancelar</Button>
          <Button variant='contained' sx={{
            backgroundColor: lightTheme.palette.primary.main,
            '&:hover': { backgroundColor: lightTheme.palette.primary.dark }
          }} onClick={() => handleClose(true)} >Aceptar</Button>
        </DialogActions>
      </Dialog>
    </ConfirmContext.Provider>
  );
};

export const useConfirm = () => useContext(ConfirmContext);
